import { createApiClient } from '@slims-pro/api-client';

/** Non-2xx response from the API, with its status for the guards. */
export class ApiError extends Error {
	constructor(
		readonly status: number,
		path: string,
	) {
		super(`${path}: HTTP ${status}`);
	}
}

export const api = createApiClient({ credentials: 'same-origin' });

// No session (OIDC, Phase 2): the API runs the login flow and brings the user back here.
api.use({
	// CSRF (ADR-006): the API refuses non-GET requests without this header.
	onRequest({ request }) {
		if (request.method !== 'GET' && request.method !== 'HEAD') {
			request.headers.set('X-Requested-With', 'slims-pro');
		}
		return request;
	},
	onResponse({ response }) {
		if (response.status === 401) {
			const returnTo = encodeURIComponent(location.pathname + location.search);
			window.location.assign(`/api/v1/auth/login?returnTo=${returnTo}`);
		}
	},
});
